/* eslint-disable arrow-body-style */
import ua from '@tencent/docs-user-agent';
import { fontListWindows } from './font-list-window';
import { fontListMac } from './font-list-mac';
import { fontListIPad } from './font-list-ipad';

export type FontList = (string | [string, string])[];

interface FontFamilyConfig {
    id: string;
    content: string;
}

const getFontListByPlatform = (): FontList => {
    if (ua.isMac) return fontListMac;
    if (ua.isIPad) return fontListIPad;
    return fontListWindows;
};

export const getFontFamilyConfigData = (): FontFamilyConfig[] => {
    return getFontListByPlatform().map((itemData) => {
        let id: string;
        let content: string;
        if (Array.isArray(itemData)) {
            [id, content] = itemData;
        } else {
            id = itemData;
            content = itemData;
        }
        return { id, content };
    });
};

/** 获取所有合法的字体列表 （合法，但不一定在对应平台正常显示） */
export const getAllLegalFontFamilyConfigData = (): FontFamilyConfig[] => {
    const fontMap: Record<string, string> = ([...fontListMac, ...fontListWindows, ...fontListIPad])
        .reduce((ftMap, itemData) => {
            if (Array.isArray(itemData)) {
                const [id, content] = itemData;
                ftMap[id] = content;
            } else {
                ftMap[itemData] = itemData;
            }
            return ftMap;
        }, {});

    return Object.entries(fontMap).map(([id, content]) => ({ id, content }));
};
